import React from "react";

//SECTIONS
import FrontPage from "../Sections/FrontPage";
import Montage from "../Sections/Montage";
import BioGif from "../Sections/BioGif";
import Philosophy from "../Sections/Philosophy";
import TeamContact from "../Sections/TeamContact";
import Slaps from "../Sections/Slaps"; 
import JRStreet from "../Sections/JRStreet";
import CollageImage from "../../src/Images/Collage.jpg";

import "../Sections/Sections.css";

export default function Homepage() {
    return <div>
                <FrontPage />
                <Philosophy />
                <Montage />
                <BioGif />
                

                
                <img loading="lazy" decoding="async" fetchPriority="low" src={CollageImage} className="break-image" alt="Collage" />
                <Slaps />
                <TeamContact />
                <JRStreet />
            </div>
}